import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAuthenticated } from './AuthAxios';
import { clearSession, hasStoredToken } from './session';
import { setUnauthorizedHandler } from '../api/client';

const AuthContext = createContext(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [status, setStatus] = useState('loading');
  const navigate = useNavigate();

  const logout = () => {
    clearSession();
    setStatus('anonymous');
    navigate('/login', { replace: true });
  };

  useEffect(() => {
    setUnauthorizedHandler(() => {
      clearSession();
      setStatus('anonymous');
      if (window.location.pathname !== '/login') {
        navigate('/login', { replace: true });
      }
    });
    return () => setUnauthorizedHandler(() => {});
  }, [navigate]);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      if (!hasStoredToken()) {
        if (!cancelled) {
          setStatus('anonymous');
        }
        return;
      }

      try {
        const ok = await userAuthenticated();
        if (cancelled) {
          return;
        }
        if (ok) {
          setStatus('authenticated');
        } else {
          clearSession();
          setStatus('anonymous');
        }
      } catch (error) {
        if (!cancelled) {
          // Token presente pero el backend local no responde: no echar al login.
          setStatus('authenticated');
        }
      }
    };

    bootstrap();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        status,
        isAuthenticated: status === 'authenticated',
        logout,
        setAuthenticated: () => setStatus('authenticated'),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
